(() => {
  if (window.__dbJudgeProductStories) return;
  window.__dbJudgeProductStories = true;

  const copy = new Map([
    ['Customer Reviews', 'WORN BY YOU'],
    ['Be the first to write a review', 'Be the first to share your pair'],
    ['Write a review', 'SHARE YOUR PAIR'],
    ['How would you rate this product?', 'How do your trainers rate?'],
    ['We would love it if you would share a bit about your experience.', 'Tell us about the fit, comfort and how they look on foot.'],
    ['Review content (Required)', 'Your pair story (Required)'],
    ['About you', 'A little about you'],
    ['Please tell us more about you.', 'A few details so we can verify your review.'],
    ['Share a picture or video', 'Show us your pair'],
    ['Upload a photo or video to support your review.', 'Add an on-foot photo or short video — optional, but always welcome.'],
    ['Submit review', 'SHARE MY PAIR'],
    ['Submit Review', 'SHARE MY PAIR'],
    ['Next', 'NEXT'],
    ['Back', 'BACK']
  ]);

  const placeholders = new Map([
    ['Start writing here...', 'How do they fit, feel and wear?'],
    ['Paste your Youtube URL here', 'Paste your YouTube video link']
  ]);

  const normalise = (value) => (value || '').replace(/\s+/g, ' ').trim();

  function replaceLeafText(scope) {
    const elements = scope.matches?.('*') ? [scope, ...scope.querySelectorAll('*')] : [...scope.querySelectorAll('*')];
    for (const element of elements) {
      if (element.children.length !== 0) continue;
      const current = normalise(element.textContent);
      const replacement = copy.get(current);
      if (replacement && current !== replacement) element.textContent = replacement;

      const placeholder = element.getAttribute?.('placeholder');
      if (placeholders.has(placeholder)) element.setAttribute('placeholder', placeholders.get(placeholder));

      const aria = element.getAttribute?.('aria-label');
      if (aria === 'Write a review') element.setAttribute('aria-label', 'Share your pair');
      if (aria === 'Share a picture or video') element.setAttribute('aria-label', 'Show us your pair');
    }
  }

  function addIntro(widget) {
    const title = widget.querySelector('.jm-review-widget-minimal-header__title');
    if (!title || title.parentElement.querySelector('.db-jm-intro')) return;
    const intro = document.createElement('p');
    intro.className = 'db-jm-intro';
    intro.textContent = 'Real pairs. Real rotations. Share how yours fit, feel and wear.';
    title.insertAdjacentElement('afterend', intro);
  }

  function enhance() {
    const widget = document.querySelector('#judgeme_product_reviews');
    if (widget) {
      replaceLeafText(widget);
      addIntro(widget);
      widget.style.setProperty('--jm-review-widget-button-color', '#007f61');
      widget.style.setProperty('--jm-widget-primary-color', '#007f61');
      widget.style.setProperty('--jm-review-widget-star-and-histogram-color', '#007f61');
    }

    document.querySelectorAll('.jdgm-write-review-modal').forEach((modal) => {
      replaceLeafText(modal);
      if (modal.getAttribute('aria-label') === 'Write a review') {
        modal.setAttribute('aria-label', 'Share your pair');
      }
    });
  }

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
